function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M106 0H18C8 0 0 8 0 18v87.9c0 9.9 8 18 18 18h88c9.9 0 17.9-8.1 17.9-18v-88c0-9.9-8-17.9-18-17.9Z",
  fill: "#00BAFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M65.7 2.8a51.7 51.7 0 1 0 0 103.5 51.7 51.7 0 0 0 0-103.5Z",
  fill: "#C0EFFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106 124c9.8 0 17.9-8 17.9-18v-2.5a42.2 42.2 0 0 0-23.1-6.8H66A42.4 42.4 0 0 0 26.4 124h79.5Z",
  fill: "#1F75DB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3 40.5h23.4V53c0 .4.6.7.9.3A6.8 6.8 0 1 1 87.2 65H82c-.2 0-.3.1-.3.2v40.6c-.6 4.8-4.3 8.6-8.7 8.6-4.8 0-8.7-4.4-8.7-9.8V93.9c-2 .5-4 .7-6 .7H57a22 22 0 0 1-22-22v-32h23.4Z",
  fill: "#1A4E99"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m57.4 54.6 5.9-.1a3.1 3.1 0 1 0-.1-6.2h-5.9a3.1 3.1 0 1 0 .1 6.3ZM39.5 54.6l4.7-.1a3.1 3.1 0 1 0-.1-6.2h-4.8a3.1 3.1 0 1 0 .2 6.3ZM47.6 61.7a3 3 0 0 1-2.6-1.5 3 3 0 0 1 1.2-4l2.2-1.3c.3-.1.5 0 .6.2.1.2 0 .5-.1.6l-2.3 1.2a2.1 2.1 0 0 0 .4 3.9 2 2 0 0 0 1.6-.2c.2-.1.5 0 .6.2.1.2 0 .5-.2.6a3 3 0 0 1-1.4.3Z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8 54.5a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2ZM42.2 54.5a3 3 0 1 0 0-6.2 3 3 0 0 0 0 6.2Z",
  fill: "#1D1D1B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2 68.3c-1.5 0-2.9-.2-4-.6a.4.4 0 1 1 .4-.8c3.5 1.4 11.4-.2 13.6-2h.6v.7a20.5 20.5 0 0 1-10.6 2.7Z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m54.3 123.7-16-24.5a14.6 14.6 0 0 0-24.5 16l5.6 8.5h34.9Z",
  fill: "#1A4E99"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7 107.8c-3-10.3-3.6-19.7-16.3-19-12.1.7-26.5 16.4-12 31 3.5 3.6 10 3.3 15.5 2.3 6-1.2 15.9-3.6 12.8-14.3Z",
  fill: "#1A4E99"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M26 110.5c-1.7 0-3.4-.8-4.5-2.3L4.3 83.6a5.5 5.5 0 1 1 9-6.3l17.2 24.6a5.5 5.5 0 0 1-4.5 8.6Z",
  fill: "#1A4E99"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.4 106.2c-2.6 0-5-2-5.4-4.6L17.2 74a5.5 5.5 0 0 1 10.9-2l4.7 27.7a5.5 5.5 0 0 1-5.4 6.5Z",
  fill: "#1A4E99"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M46 112.4a.4.4 0 0 1-.4-.5c.1-.6.4-6.2-4-10.2-3.4-3.1-8.6-4.1-15.3-3a4 4 0 0 0-1.6 7.5c.9.7 2 1 3 .7 4-.7 7-.4 8.4 1 1.4 1.2 1.3 3.3 1.3 3.3 0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.5s0-1.7-1-2.6c-1.2-1.1-4-1.4-7.6-.7a5 5 0 0 1-5-7.8 5 5 0 0 1 3.3-2c7-1.3 12.4-.3 16 3a13.8 13.8 0 0 1 4.3 11c0 .2-.2.4-.4.4Z",
  fill: "#fff"
});

function SvgPersonReaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 124,
    height: 124,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = React.forwardRef(SvgPersonReaction);
export default __webpack_public_path__ + "static/media/person-reaction.6394b729.svg";
export { ForwardRef as ReactComponent };